<app-report-header
  crumbLabel="Capital Growth Calculator"
  [loadingDownload]="loadingDownloadbtn"
  (download)="convetToPDF()"
  (recalculate)="startagain()">
</app-report-header>

<!-- Capital Growth Result — white professional report design -->
<div class="rpt-page" id="contentToConvert">

  <!-- ── Masthead ── -->
  <div class="rpt-wrap rpt-masthead">
    <div class="rpt-masthead__eyebrow">Capital Growth Report</div>
    <h1 class="rpt-masthead__title">{{calcData?.City || 'UK'}} — Capital Growth Analysis over {{investedTenure}} Years</h1>
    <p class="rpt-masthead__subtitle" *ngIf="calcData?.ForeignBuyer === '1'">
      Projected property value and total return on a £{{propertyValue | number:'1.0-0'}} asset, modelled with {{calcData?.capitalgrowth}}% annual capital growth and {{calcData?.fxgrowth}}% FX appreciation.
    </p>
    <p class="rpt-masthead__subtitle" *ngIf="calcData?.ForeignBuyer !== '1'">
      Projected property value and total return on a £{{propertyValue | number:'1.0-0'}} asset, modelled with {{calcData?.capitalgrowth}}% annual capital growth.
    </p>
    <div class="rpt-masthead__meta">
      <span class="rpt-meta-pill">Property Value <strong>{{propertyValue | currency:'GBP':'symbol':'1.0-0'}}</strong></span>
      <span class="rpt-meta-pill">Growth p.a. <strong>{{calcData?.capitalgrowth}}%</strong></span>
      <span class="rpt-meta-pill">Period <strong>{{investedTenure}} years</strong></span>
      <span class="rpt-meta-pill" *ngIf="calcData?.homecurrencyText">Home Currency <strong>{{calcData?.homecurrencyText}}</strong></span>
      <span class="rpt-meta-pill rpt-meta-pill--accent">Exit Value <strong>{{calculatedCapitalGrowth | currency:'GBP':'symbol':'1.0-0'}}</strong></span>
    </div>
  </div>

  <!-- ── §01 KPI Section ── -->
  <section class="rpt-wrap rpt-section">
    <div class="rpt-section__head">
      <div>
        <div class="rpt-section__num">01 · Results</div>
        <h2 class="rpt-section__title">Projected returns</h2>
        <p class="rpt-section__sub" *ngIf="calcData?.ForeignBuyer === '1'">Total return and projected exit value in GBP and your home currency.</p>
        <p class="rpt-section__sub" *ngIf="calcData?.ForeignBuyer !== '1'">Total return and projected exit value in GBP.</p>
      </div>
      <span class="rpt-section__tag">{{investedTenure}}-year horizon · {{calcData?.ForeignBuyer === '1' ? calcData?.homecurrencyText : 'GBP'}}</span>
    </div>

    <div class="rpt-kpi-strip">
      <!-- Hero: Total Return % -->
      <div class="rpt-kpi-hero">
        <div class="rpt-kpi-hero__eyebrow">Total {{calcData?.ForeignBuyer === '1' ? calcData?.homecurrencyText : 'GBP'}} Return</div>
        <div class="rpt-kpi-hero__body">
          <div class="rpt-kpi-hero__value">{{CaptitalGrowthinHomeCurrencyArray[CaptitalGrowthinHomeCurrencyArray.length-1]?.toFixed(1)}}<span class="rpt-kpi-hero__unit">%</span></div>
          <div class="rpt-kpi-hero__label" *ngIf="calcData?.ForeignBuyer === '1'">Including FX appreciation over {{investedTenure}} years</div>
          <div class="rpt-kpi-hero__label" *ngIf="calcData?.ForeignBuyer !== '1'">Capital appreciation over {{investedTenure}} years</div>
        </div>
        <p class="rpt-kpi-hero__caption" *ngIf="calcData?.ForeignBuyer === '1'">
          Total appreciation on £{{propertyValue | number:'1.0-0'}} property with {{calcData?.capitalgrowth}}% annual capital growth and {{calcData?.fxgrowth}}% FX growth.
        </p>
        <p class="rpt-kpi-hero__caption" *ngIf="calcData?.ForeignBuyer !== '1'">
          Total appreciation on £{{propertyValue | number:'1.0-0'}} property with {{calcData?.capitalgrowth}}% annual capital growth.
        </p>
      </div>

      <!-- Side: Initial Value + Exit Value -->
      <div class="rpt-kpi-side rpt-kpi-side--2">
        <div class="rpt-kpi-card">
          <div class="rpt-kpi-card__label">Initial Value ({{calcData?.ForeignBuyer === '1' ? calcData?.homecurrencyText : 'GBP'}})</div>
          <div class="rpt-kpi-card__value" *ngIf="calcData?.ForeignBuyer === '1'">{{formatCurrency(propertyValueHomeCurrency, calcData?.homecurrencyText)}}</div>
          <div class="rpt-kpi-card__value" *ngIf="calcData?.ForeignBuyer !== '1'">{{propertyValue | currency:'GBP':'symbol':'1.0-0'}}</div>
          <div class="rpt-kpi-card__foot" *ngIf="calcData?.ForeignBuyer === '1'">{{propertyValue | currency:'GBP':'symbol':'1.0-0'}}</div>
        </div>
        <div class="rpt-kpi-card">
          <div class="rpt-kpi-card__label">Exit Value ({{calcData?.ForeignBuyer === '1' ? calcData?.homecurrencyText : 'GBP'}})</div>
          <div class="rpt-kpi-card__value" *ngIf="calcData?.ForeignBuyer === '1'">{{formatCurrency(CaptitalGrowthinHomeCurrency, calcData?.homecurrencyText)}}</div>
          <div class="rpt-kpi-card__value" *ngIf="calcData?.ForeignBuyer !== '1'">{{calculatedCapitalGrowth | currency:'GBP':'symbol':'1.0-0'}}</div>
          <div class="rpt-kpi-card__foot" *ngIf="calcData?.ForeignBuyer === '1'">{{calculatedCapitalGrowth | currency:'GBP':'symbol':'1.0-0'}}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ── §02 Assumptions ── -->
  <section class="rpt-wrap rpt-section">
    <div class="rpt-section__head">
      <div>
        <div class="rpt-section__num">02 · Inputs</div>
        <h2 class="rpt-section__title">Your assumptions</h2>
      </div>
    </div>
    <div class="rpt-card">
      <div class="rpt-card__body">
        <div class="rpt-arow">
          <span class="rpt-arow__key">City</span>
          <span class="rpt-arow__val">{{calcData?.City || 'UK'}}</span>
        </div>
        <div class="rpt-arow">
          <span class="rpt-arow__key">Property Value</span>
          <span class="rpt-arow__val">{{propertyValue | currency:'GBP':'symbol':'1.0-0'}}</span>
        </div>
        <div class="rpt-arow">
          <span class="rpt-arow__key">Capital Growth p.a.</span>
          <span class="rpt-arow__val">{{calcData?.capitalgrowth}}%</span>
        </div>
        <div class="rpt-arow" *ngIf="calcData?.ForeignBuyer === '1'">
          <span class="rpt-arow__key">FX Growth p.a.</span>
          <span class="rpt-arow__val">{{calcData?.fxgrowth}}%</span>
        </div>
        <div class="rpt-arow">
          <span class="rpt-arow__key">Investment Period</span>
          <span class="rpt-arow__val">{{investedTenure}} years</span>
        </div>
        <div class="rpt-arow" *ngIf="calcData?.ForeignBuyer === '1'">
          <span class="rpt-arow__key">Home Currency</span>
          <span class="rpt-arow__val">{{calcData?.homecurrencyText}}</span>
        </div>
        <div class="rpt-arow" *ngIf="calcData?.ForeignBuyer === '1'">
          <span class="rpt-arow__key">Exchange Rate</span>
          <span class="rpt-arow__val">{{calcData?.homecurrency}} {{calcData?.homecurrencyText}}/£</span>
        </div>
      </div>
    </div>
  </section>

  <!-- ── §03 Chart ── -->
  <section class="rpt-wrap rpt-section">
    <div class="rpt-section__head">
      <div>
        <div class="rpt-section__num">03 · Trajectory</div>
        <h2 class="rpt-section__title">Growth over time</h2>
        <p class="rpt-section__sub">Cumulative percentage appreciation year by year — GBP vs. home currency.</p>
      </div>
    </div>
    <div class="rpt-card">
      <div class="rpt-chart-wrap cgr-chart-wrap">
        <canvas id="canvas"></canvas>
      </div>
      <div class="cgr-legend">
        <span class="cgr-legend-item">
          <span class="cgr-legend-dot" style="background:#132147"></span>
          GBP Growth
        </span>
        <span class="cgr-legend-item" *ngIf="calcData?.ForeignBuyer === '1'">
          <span class="cgr-legend-dot" style="background:#23B14B"></span>
          {{calcData?.homecurrencyText}} Growth (incl. FX)
        </span>
      </div>
    </div>
  </section>

  <!-- ── §04 Year-by-Year Table ── -->
  <section class="rpt-wrap rpt-section">
    <div class="rpt-section__head">
      <div>
        <div class="rpt-section__num">04 · Year-by-Year</div>
        <h2 class="rpt-section__title">Annual projection</h2>
      </div>
    </div>
    <div class="rpt-card">
      <div class="rpt-tbl-wrap">
        <table class="rpt-tbl">
          <thead>
            <tr>
              <th>Year</th>
              <th>GBP Value</th>
              <th *ngIf="calcData?.ForeignBuyer === '1'">{{calcData?.homecurrencyText}} Value</th>
              <th>GBP Growth</th>
              <th *ngIf="calcData?.ForeignBuyer === '1'">{{calcData?.homecurrencyText}} Growth</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let yr of calculatedCapitalGrowtharray; let i=index">
              <td style="font-weight:600; color: var(--navy)">{{i+1}}</td>
              <td>{{gbpValuesArray[i] | currency:'GBP':'symbol':'1.0-0'}}</td>
              <td *ngIf="calcData?.ForeignBuyer === '1'">{{formatCurrency(homeCurrencyValuesArray[i], calcData?.homecurrencyText)}}</td>
              <td class="rpt-tbl__accent" style="text-align:left">+{{yr.toFixed(1)}}%</td>
              <td *ngIf="calcData?.ForeignBuyer === '1'" class="rpt-tbl__accent" style="text-align:left">+{{CaptitalGrowthinHomeCurrencyArray[i].toFixed(1)}}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>

</div>

<app-report-footer
  [today]="today"
  [loadingDownload]="loadingDownloadbtn"
  [loadingShare]="loadingSharebtn"
  (download)="convetToPDF()"
  (recalculate)="startagain()"
  (share)="shareReport($event)">
</app-report-footer>
